import { IFormValues } from './interfaces/IFormValues';
import { ICreateWireFromACHPushRequest } from './interfaces/ICreateWireFromACHPushRequest';

export const convertFormValuesToRequest = ({
  ach_account_id,
  amount,
  category,
  escrow_file_id,
  memo,
  routing_number,
  state_abbreviation,
  ach_push_id,
}: IFormValues) =>
  ({
    ach_account_id,
    amount,
    category,
    escrow_file_id,
    memo,
    routing_number,
    state_abbreviation,
    ach_push_id,
  } as ICreateWireFromACHPushRequest);
